module.exports = __webpack_public_path__ + "img/4.fd600c74.png";